import React from "react";

export const AppContext = {
    IsEnableMergeCalls: true,
};